import { ActivityType } from './Lesson.types'

export const ACTIVITY_TYPES_WITH_CUSTOM_TIME_TRACKING = [
  ActivityType.Video,
  ActivityType.RecordVideoActivity,
  ActivityType.Exercise2,
  ActivityType.WordPractice
]

export const isActivityTypeWithCustomTimeTracking = (activityType: ActivityType | undefined) =>
  activityType ? ACTIVITY_TYPES_WITH_CUSTOM_TIME_TRACKING.includes(activityType) : false
